<template>
  <div>
    <confirmation-popup
        title="Warning"
        message="Are you sure you want to delete this property??"
        :id="confirmationDialogId" @on-confirm="onBookingPropertyDeleteConfirm"></confirmation-popup>
    <div id="tabs-customerType" role="tabpanel">
      <div id="collapsetwo" class="panel-collapse">
        <div class="panel-body no-padding">
          <div class="panel-body  no-padding">
            <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
              <div v-for="(property,key) in properties" :key="key"    class="">
                <div v-if="property.details && Object.keys(property.details).length <= 10" class="" style="height: 52px;" role="tab"
                     :id="'heading'+propertyType+key">
                  <div class="col-md-12 col-xs-12 propert-div-title p-left-0">
                    <h4 class="panel-title property-title float-left">
                      <a class="customer-property-title" role="button"
                         data-toggle="collapse" :href="'#collapse'+propertyType+key" :id="property.property_id"
                         aria-expanded="true" :aria-controls="'collapse'+propertyType+key">
                        {{ property.property_name }}
                      </a>
                    </h4>
                    <booking-property-creation-popup v-if="itemType === 'customerprofile'" :view-booking="viewBooking"  :property="property" :customer-id="customerId"
                                                      :country-code="countryCode" :country-key="countryKey" :date-format="dateFormat"
                                                      :id="`create_popup_booking_proparty_${property.property_id}`" :booking-id="bookingId"></booking-property-creation-popup>
                    <h4>
                      <a v-if="itemType === 'customerprofile'" class="float-right" data-toggle="modal" :data-target="`#create_popup_booking_proparty_${property.property_id}`">
                        <svg  width="20" height="20" style="fill: #2E4051; display: inline;" v-if="canShowCustomerBillingDetails(property.property_name)"
                              viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                              fill="#03A9F4"/>
                        </svg>
                      </a>
                    </h4>
                  </div>
                </div>
                <div v-if="property.details && Object.keys(property.details).length <= 10" :id="'collapse'+propertyType+key"
                     class="panel-collapse collapse in panel-collapse-properties"
                     role="tabpanel" :aria-labelledby="'heading'+key">
                  <div class="panel-body panel-body-customer-property" v-if="canShowCustomerBillingDetails(property.property_name)">
                    <booking-property-item v-for="(detail,key) of property.details" :key="key" :property="detail"
                                            :property-name="property.property_name" :country-code="countryCode"
                                            :property-details="detail.detailobject"
                                            :date-format="dateFormat"
                                            :customer-id="customerId"
                                            :booking-id="bookingId"
                                            :country-key="countryKey"
                                            :invoice-id="invoiceId"
                                            :booking-info='bookingInfo'
                                            :view-booking = "viewBooking"
                    >
                    </booking-property-item>

                  </div>
                  <div v-else class="ibox-content inquiry_customer_mop border-style">
                    <span class="select-services-dropdown-title">Bill payer details are hidden by admin</span>
                  </div>
                </div>
                <div v-if="property.details && Object.keys(property.details).length > 10" class="" style="height: 52px;" role="tab"
                     :id="'heading'+key">
                  <div class="col-md-10 col-xs-7 propert-div-title">
                    <span class="property-title">
                        {{ property.property_name }}
                    </span>
                  </div>
                  <div class="col-md-2 col-xs-5 property-list-separate">
                    <span class="properties-number">{{ property['details'].length }}</span>
                    <a href="#" @click="goToSeparateCustomerPropertiesPage(property.property_id,customerId)" class="details_info_opt">
                      <svg class="m-top-15" width="12" height="20" viewBox="0 0 12 20" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M0.841719 18.1299L2.62172 19.8999L12.5117 9.9999L2.61172 0.0999031L0.841719 1.8699L8.97172 9.9999L0.841719 18.1299Z"
                            fill="rgb(46, 64, 81)"/>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              <!--            <?php $i++;-->
              <!--                                    } ?>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import CustomerPropertyCreationPopup from "@/modules/CustomerProperties/components/CustomerPropertyCreationPopup";
import {EventBus} from "@/events/event-bus";
import {deleteBookingProperties, getBookingProperty} from "@/modules/Booking/api/properties";

export default {
  name: "BookingProperties",
  components: {CustomerPropertyCreationPopup},
  props: {
    base64EncodedProperties: '',
    customerId: null,
    countryCode: '',
    countryKey:'',
    dateFormat: '',
    propertyType: '',
    itemType: '',
    bookingId:'',
    invoiceId:'',
    bookingInfo:'',
    viewBooking:'',
    canSeeCustomer: false,
   loggedUserRole :null,
  },
  data() {
    return {
      i: 0,
      toBeDeletedProperty: null,
      confirmationDialogId: 'booking-property-confirmation',
      properties: this.base64EncodedProperties,
      separateCustomerPropertiesPageLink: '/properties'
    }
  },
  methods: {
    getTargetedPropertyByCustomerPropertyId(property) {
      return this.properties.find(prop => {
        for (let oneDetail of prop.details) {
          if (oneDetail.customer_property_id == property.customer_property_id)
            return true
        }
      })
    },

    canShowCustomerBillingDetails(property) {
       if(this.loggedUserRole !='contractor' ||  this.canSeeCustomer ){
         return  1
       }
       else {
          if(property =='Bill payer'){
           return  0
         }else {
           return 1
         }
       }
    },

    getTargetedPropertyByPropertyId(property) {
      return this.properties.find(prop => {
        // for (let oneDetail of prop.details) {
        if (prop.property_id == property.property_id)
          return true
        // }
      })
    },
    goToSeparateCustomerPropertiesPage(property_id, customer_id) {
      window.location.replace(`${this.separateCustomerPropertiesPageLink}/${property_id}/${customer_id}`)
    },
    removePropertyVisually(property) {
      let target = this.getTargetedPropertyByCustomerPropertyId(property)
      target.details.splice(target.details.indexOf(property), 1)
      this.$forceUpdate()
    },
    initiateListeners() {

      EventBus.$on('onBookingPropertyDeleted', property => {
        this.toBeDeletedProperty = property
        $(`#${this.confirmationDialogId}`).modal('show')
      })

      EventBus.$on('onCustomerPropertyCreated', property => {
        let target = this.getTargetedPropertyByPropertyId(property)
        property.value = property.customer_primary_field_vlaue
        if (target.hasOwnProperty('details')) {
          target.details.push(property)
        } else {
          target.details = []
          target.details.push(property)
        }
        if ($('#' + property.property_id).hasClass('collapsed')) {
          $('#' + property.property_id).trigger('click')
        }
        this.$forceUpdate()

      }),

        EventBus.$on('onCustomerPropertyCreatedCustom', property => {
            getBookingProperty(this.bookingId).then(response => {
               this.properties =  response.data;
            })
        })

      EventBus.$on('onCustomerPropertyConfirmDeleted',property=>{
        this.toBeDeletedProperty = property
        this.onBookingPropertyDeleteConfirm()
      })
    },
    onBookingPropertyDeleteConfirm() {
      deleteBookingProperties(this.toBeDeletedProperty)
          .then(response => {
            this.removePropertyVisually(this.toBeDeletedProperty)
          })

    },

  },
  mounted() {
    this.initiateListeners()
  }
}
</script>

<style scoped>

.customer-property-item {
    margin-top: 0rem !important;
}
.add-customer-property {
  border: none !important;
}

.property-title {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
}

.properties-number {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  padding: 0px 20px;
}
.property-list-separate{
  text-align: end;
}
.panel-body {
    padding: 0px !important;
}

</style>